import React, { Component, PropTypes } from 'react';
import { Field } from 'redux-form';
import classnames from 'classnames';
import omit from 'lodash/omit';
import { timeOptions } from 'help/constants';
import {
  TextInputField, EmailInputField, SelectField, RadioButtonField, TextAreaField
} from 'common/components/form_fields';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import { trackGoogle } from 'common/tracking';
import IntercomChat from 'common/containers/intercom_chat';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';


export default class ConsultationChinese extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    trackGoogle('contact', 'viewed contact form', 'design consultation');
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "Design consultation",
        "variant": "chinese",
      }
    );
  }

  onSubmit(values) {
    trackGoogle('contact', 'submitted contact form', 'design consultation');
    /* only send pertinent information to the server */
    const data = values.via_email? omit(values, ['phone_number' ]) : values;
    this.props.onSubmit({ ...data, category: 'consultation' });
  }

  render() {
    const { handleSubmit, isLoading, success, failure, formName, viaEmail, canChat,
      showingChat, toggleChat } = this.props;
    const classes = classnames('help-content contact-page', { succeeded: success, failed: failure });

    return (<div className="l-content help-page" id="content">
      <div className={classes}>
        <Meta
          title="Contact | Help | crowdspring"
          meta={[
            { name: 'description', content: 'How to contact crowdspring - find answers, call, chat or email us, 24/7' },
            { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' }
          ]}
          link={[{ rel: 'canonical', href: getCanonicalURL('/help/contact/consultation/') }]}
        />
        <div className="row">
          <div className="columns small-16 medium-10 large-12">
            <section className="contact-form">
              <div className="row align-center">
                <div className="small-16 medium-16 large-12 columns">
                  <div className="contact-success">
                    <h3><i className="fa fa-check-circle" /> 信息已发送！</h3>
                    <h4>我的下一步是什么？</h4>
                    <p>
                       我们客服团队的设计顾问会在24小时内和您联络。我们将会问您一些关于您项目的详细问题，同时介绍 crowdspring 会如何帮您达成您的目标。
                    </p>
                    <p>
                       您也可以在我们的 <a href="/help/">帮助中心 </a> 里找到一些常见问题的答案。
                    </p>
                  </div>
                  <div className="contact-failure">
                    <h3><i className="fa fa-exclamation-circle" /> 我们无法发送您的信息！</h3>
                    <h4>接下来会怎样？</h4>
                    <p>
                      请给我们发邮件到 <a href="mailto:support@crowdspring.com">support@crowdspring.com</a>
                      您也可以在 <a href="/help/">帮助中心</a> 里找到常见问题的答案。
                    </p>
                  </div>
                  <form onSubmit={handleSubmit(this.onSubmit)} >
                    <div className="form-intro">
                      <h1>申请设计咨询.</h1>
                      <h3>完全免费，无需购买.</h3>
                      <p>
                        一位设计专家会很快联系您来讨论关于您项目的目标和顾虑，并回答您关
                        <br className="show-for-large"/> 于crowdspring的任何问题。
                      </p>
                      <p>
                        设计咨询可以用普通话或者英语进行。
                      </p>
                      <p>
				              	电话咨询时间为北京时间上午9点到下午2点。
                      </p>
                    </div>
                    <Field name="full_name" component={TextInputField} label="姓名" />
                    <Field name="via_email" component={RadioButtonField} props={{ value: true }}
                      label="我希望通过电子邮件咨询" />
                    <Field name="via_email" component={RadioButtonField} props={{ value: false }}
                      label="我希望通过电话咨询" />
                    <Field name="email" component={EmailInputField} label="电子邮箱" />
                    { !viaEmail &&
                    <Field
                      name="phone_number"
                      component={TextInputField}
                      label="电话号码"
                      placeholder="+86 555.555.1234"
                    /> }
                    <Field
                      name="message"
                      label="您有什么需求"
                      component={TextAreaField}
                      rows={5}
                    />
                    {!isLoading && <button
                      className="btn btn-primary"
                      type="submit"
                    >
                      发送
                                   </button>}
                    {isLoading && <button
                      type="button"
                      className="btn btn-primary"
                    >
                      Sending...
                                  </button>}
                  </form>
                </div>
              </div>
            </section>
          </div>
          <aside className="small-16 medium-6 large-4 columns sidebar">

            <section>
              <h4>Social</h4>
              <ul className="social-links">
                <li>
                  <a href="https://www.facebook.com/crowdspring/" rel="nofollow noopener noreferrer" target="_blank">
                    <i className="fa fa-fw fa-facebook" /> Friend Us
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/crowdspring" rel="nofollow noopener noreferrer" target="_blank">
                    <i className="fa fa-fw fa-twitter" /> Follow @crowdspring
                  </a>
                </li>
              </ul>
            </section>

          </aside>
        </div>
      </div>
      { showingChat && <IntercomChat expandOnShow={true} /> }
    </div>);
  }
}

ConsultationChinese.propTypes = {
  viaEmail: PropTypes.bool,
  canChat: PropTypes.bool,
  showingChat: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  toggleChat: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  success: PropTypes.bool,
  formName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./marketing/components/consultation_chinese.jsx